import {take, delay, put} from 'redux-saga/effects';

export function* calendars() {
  try {
    while (true) {
      const { result } = yield window.gapi.client.calendar.calendarList.list();
      yield put({
        type: 'GOOGLE_CALENDAR_LIST_RECEIVED',
        ...result,
      });
      yield take('GOOGLE_CALENDAR_GET_CALENDARS');
      yield delay(1000);
    }
  } catch (error) {
    if (error.status == 401) {
      yield put({
        type: 'GOOGLE_CALENDAR_SIGN_OUT',
      });
    }
    throw error;
  }
}
